
import A from '../images/3.png'

const LoadingCop=()=>{
    return <>
    <div className="allLoadingOverlay">
        <img src={A}/>
    </div>
    </>
}
export default LoadingCop